export const testAttributes = {
    TOPICS_FILTER_CONTAINER: 'topics-filter-container',
}